import { parsePrice } from "@/pages/Bid/Analytics/utils";
import { SmfProduct } from "@/types/itemsheet";
import { ColumnDef } from "@tanstack/react-table";

const cellTextStyle = "text-xs text-gray-A font-normal";

export const searchTableColumn: ColumnDef<SmfProduct>[] = [
  {
    header: "제품 번호",
    accessorKey: "id",
    cell: ({ row }) => <p className={cellTextStyle}>{row.original.id}</p>,
    size: 120,
  },
  {
    header: "제품명",
    accessorKey: "name",
    cell: ({ row }) => <p className={cellTextStyle}>{row.original.name}</p>,
    size: 215,
  },
  {
    header: "디비전",
    accessorKey: "division",
    cell: ({ row }) => <p className={cellTextStyle}>{row.original.division}</p>,
    size: 75,
  },
  {
    header: "규격",
    accessorKey: "spec",
    cell: ({ row }) => <p className={cellTextStyle}>{row.original.spec}</p>,
    size: 75,
  },
  {
    header: "단위",
    accessorKey: "unit",
    cell: ({ row }) => <p className={cellTextStyle}>{row.original.unit}</p>,
    size: 75,
  },
  {
    header: "판매가",
    accessorKey: "list_price",
    cell: ({ row }) => {
      const price = row.original.list_price;
      const parsedPrice = parsePrice(price);

      return (
        <p className={cellTextStyle}>
          {parsedPrice ? parsedPrice.toLocaleString() + "원" : "-"}
        </p>
      );
    },
    size: 120,
  },
  {
    header: "데이터 소스",
    accessorKey: "source",
    cell: ({ row }) => <p className={cellTextStyle}>{row.original.source}</p>,
    size: 80,
  },
  {
    id: "select",
    cell: ({ table, row }) => {
      return (
        <input
          type="radio"
          name="select-row"
          checked={row.getIsSelected()}
          onChange={() => {
            table.setRowSelection({
              [row.id]: true,
            });
          }}
          className="h-4 w-4 accent-dark-red"
        />
      );
    },
    size: 60,
  },
];
